/*
 * @Author: wuchenge
 * @Date:   2022-04-06 18:27:02
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-04-06 20:55:17
 */
export const DETAIL_CHANGE_DETAIL = "DETAIL_CHANGE_DETAIL";
